var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C12.2386 0 10 2.23858 10 5V6.66667H8.33333C3.73096 6.66667 0 10.3976 0 15C0 19.6024 3.73096 23.3333 8.33333 23.3333H10.8535C12.7351 28.6568 17.5364 32.601 23.3333 33.2418V46.6667H13.3333V50H36.6667V46.6667H26.6667V33.2418C32.4636 32.601 37.2649 28.6568 39.1465 23.3333H41.6667C46.269 23.3333 50 19.6024 50 15C50 10.3976 46.269 6.66667 41.6667 6.66667H40V5C40 2.23858 37.7614 0 35 0H15ZM40 10V18.3333C40 18.8967 39.9689 19.4528 39.9085 20H41.6667C44.4281 20 46.6667 17.7614 46.6667 15C46.6667 12.2386 44.4281 10 41.6667 10H40ZM8.33333 10H10V18.3333C10 18.8967 10.0311 19.4528 10.0915 20H8.33333C5.57191 20 3.33333 17.7614 3.33333 15C3.33333 12.2386 5.57191 10 8.33333 10Z",
    fill: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyRed);
export default __webpack_public_path__ + "static/media/trophy-red.4da7221c69f3c3b4a30fa0e58e09481b.svg";
export { ForwardRef as ReactComponent };